import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { api } from "../lib/api";

export default function Journal() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/posts").then((r) => setPosts(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  return (
    <main className="pt-24 md:pt-28" data-testid="page-journal">
      <section className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="h-eyebrow mb-6">§ The Journal</div>
        <h1 className="h-display text-5xl md:text-7xl leading-[0.95] max-w-4xl">
          Behind-the-scenes,<br/>
          <span className="italic font-serif-editorial text-[var(--gold)] font-light">and quieter dispatches.</span>
        </h1>
        <p className="font-serif-editorial text-lg md:text-xl leading-relaxed text-[var(--ink)]/80 mt-10 max-w-2xl">
          Tutorials, autobiographical notes, and poetic postscripts to the projects the world will only see the final frame of.
        </p>
      </section>

      <section className="max-w-[1400px] mx-auto px-6 md:px-12 mt-20 md:mt-24 space-y-12 md:space-y-16">
        {loading && <div className="h-eyebrow text-[var(--ink-muted)]">Loading dispatches…</div>}
        {!loading && posts.length === 0 && (
          <div className="font-serif-editorial italic text-[var(--ink)]/70 text-lg">No entries published yet — the studio is quiet this month.</div>
        )}
        {posts.map((p, i) => (
          <motion.article
            key={p.id}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.9, delay: i * 0.05, ease: [0.22, 1, 0.36, 1] }}
            className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-10 border-t border-white/5 pt-8 md:pt-10"
            data-testid={`journal-entry-${p.slug}`}
          >
            <div className="md:col-span-2">
              <div className="numeral text-4xl md:text-6xl">{String(i + 1).padStart(2, "0")}</div>
              <div className="h-eyebrow mt-2 text-[var(--ink-muted)]">{p.category}</div>
            </div>
            <div className="md:col-span-6">
              <Link to={`/journal/${p.slug}`} className="block group">
                <h2 className="h-display text-3xl md:text-5xl leading-[1.05] group-hover:text-[var(--gold)] transition-colors">
                  {p.title}
                </h2>
                <p className="font-serif-editorial text-lg md:text-xl italic text-[var(--ink)]/70 mt-6">{p.excerpt}</p>
                <span className="inline-flex items-center gap-2 mt-8 font-sans-display uppercase tracking-[0.3em] text-[11px] text-[var(--gold)] border-b border-[var(--gold)]/40 group-hover:border-[var(--gold)] pb-2">
                  Read the entry →
                </span>
              </Link>
            </div>
            <div className="md:col-span-4">
              {p.cover_image && (
                <Link to={`/journal/${p.slug}`} className="clip-frame block h-64 md:h-80 bg-[#111]">
                  <img src={p.cover_image} alt={p.title} loading="lazy" />
                </Link>
              )}
            </div>
          </motion.article>
        ))}
      </section>

      <div className="h-16 md:h-24" />
    </main>
  );
}
